import { render, staticRenderFns } from "./ModalGroupCreateInfo.vue?vue&type=template&id=24f5f0c9&scoped=true"
import script from "./ModalGroupCreateInfo.vue?vue&type=script&lang=js"
export * from "./ModalGroupCreateInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupCreateInfo.vue?vue&type=style&index=0&id=24f5f0c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5f0c9",
  null
  
)

export default component.exports